import { render, staticRenderFns } from "./NonConformityActionList.vue?vue&type=template&id=4fc15f0b&"
import script from "./NonConformityActionList.vue?vue&type=script&lang=js&"
export * from "./NonConformityActionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports